import { render, staticRenderFns } from "./legalSubjectInfo.vue?vue&type=template&id=b4f75f44&scoped=true&"
import script from "./legalSubjectInfo.vue?vue&type=script&lang=js&"
export * from "./legalSubjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./legalSubjectInfo.vue?vue&type=style&index=0&id=b4f75f44&prod&scoped=true&lang=css&"
import style1 from "./legalSubjectInfo.vue?vue&type=style&index=1&id=b4f75f44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f75f44",
  null
  
)

export default component.exports